import { Divider, styled } from "@mui/material";

export const PhotoDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(4, 0),
}));
